module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_6005.99528399.png";